module.exports = {
  "CS_FE_Select_Product_VbhT": "可选择产品研发角色",
  "CS_status_Dibi_hJVY": "确认继续{{time_second}}",
  "CS_system_Submission_cEep": "提交",
  "CS_1_WiFi_pyYD": "WiFi",
  "CS_FE_You_can_yIrn": "您可以在下方选择您想申请的权限并点击“申请”",
  "CS_status_SYOk_iYUs": "企业级",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "更多信息详见《客服系统权限指南》",
  "CS_status_ZoGi_sjyC": "司机中心",
  "CS_1_Environment_Bitb": "环境",
  "CS_1_View_Current_IOCz": "查看当前权限",
  "CS_optimazation__CALn": "由于超时未操作，状态已自动变为离线状态，请刷新页面",
  "CS_1_Upgrade_current_dlbi": "升级当前权限",
  "CS_optimazation_You_have_PlRk": "你已经持续{{time_duration}}分钟没有在{{workbench_name}}进行任何操作，请确认是否还在{{workbench_name}}继续工作。",
  "CS_optimazation__akmu": "离线",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "如果您是非客服同学：",
  "CS_status_ixVR_bjQc": "销售",
  "CS_feedback_Feedback_bGXI": "反馈",
  "CS_optimazation__ZkZb": "继续{{work_status}}",
  "CS_System_ZQjn_eCbz": "培训过技能类型",
  "CS_status_CjDQ_uaVo": "反作弊",
  "CS_Status_In_the_PrHj": "厕所中",
  "CS_1_Thank_you_WUlL": "感谢您的评论！",
  "CS_status_ErSl_RYFT": "外呼",
  "CS_1_Log_in_sMmF": "登出",
  "CS_status_HxNd_EpND": "车载监控",
  "CS_status_HMDn_eBqC": "伙伴接触",
  "CS_status_zoxI_Nral": "当前服务类型为{{service_type}}",
  "CS_feedback_1_Please_IBbL": "1.请描述在操作什么功能时，遇到了什么问题",
  "CS_1_Closing_Online_tykf": "关闭在线客服服务",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "请选择相应的权限",
  "CS_1_Open_automatic_PZyZ": "开启自动分单",
  "CS_FE_Ark_Visitor_pMCT": "方舟访客角色",
  "CS_1_Enter_text_NYGo": "请输入文字",
  "CS_status_WEAx_MWhv": "安全",
  "CS_System_lIGK_Ukwr": "当前技能类型",
  "CS_optimazation_Telephone_workstations_TBZP": "电话工作台",
  "CS_system_Name_of_QEFT": "岗位名称",
  "CS_status_dweh_wRWT": "注册审核",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "抱歉，您当前没有权限进入系统，您可以根据以下提示进行操作",
  "CS_optimazation__work_JhhB": "{{work_status}}已超过{{time_duration}}分钟，请确认是否继续{{work_status}}",
  "CS_Workbench_Online_Customer_yXxN": "在线客服工作台",
  "CS_status_wfIq_oGhU": "舆情处理",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "您可以在下方选择您想申请的权限并点击“申请”\n\n如果您是客服产研：可选择产品研发角色\n\n如果您是其他角色（IBT业务产研、运营、国内同学）：可选择方舟访客角色",
  "CS_optimazation_Time_out_sqTe": "超时提醒",
  "CS_1_Country_ilYw": "国家",
  "CS_1_Closed_automatic_jUvk": "关闭自动分单",
  "CS_1_System_Category_rAJC": "系统品类",
  "CS_status_aobY_gRor": "{{status_name}}已超过{{hour_time}}小时，请确认是否继续{{status_name}}",
  "CS_FE_If_you_lCHy": "如果您是客服产研：",
  "CS_status_qORz_iUKj": "催收",
  "CS_optimazation_The_status_hqOj": "状态切换失败，请登录Genesys系统",
  "CS_optimazation_After_the_dZsk": "话后处理",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "如果您是客服同学：",
  "CS_feedback_Please_upload_zHqW": "2.请上传完整的图片帮助我们理解问题",
  "CS_system_Sectoral_information_JizK": "部门信息",
  "CS_optimazation__zXnN": "{{work_status}}超时",
  "CS_status_eJtD_Xawt": "技术支持",
  "CS_1_Personal_settings_eXQD": "个人设置",
  "CS_optimazation_Asynchronous_workstations_JwBF": "异步工作台",
  "CS_status_YyJG_Khkr": "一线客服",
  "CS_FE_Product_R_RxVt": "产品研发角色",
  "CS_1_Online_Customer_SvgB": "在线客服服务中",
  "CS_status_pySZ_YnQN": "内容审核",
  "CS_1_Open_Online_umkV": "开启在线客服服务",
  "CS_1_Languages_hMbf": "语言",
  "CS_system_Immediate_superior_VDep": "直属上级",
  "CS_1_Personal_settings_uOXW": "个人设置",
  "CS_FE_Choose_Ark_VJpl": "可选择方舟访客角色",
  "CS_1_Permissions_MuvF": "权限",
  "CS_FE_If_you_WAuP": "如果您是其他角色（IBT业务产研、运营、国内同学）：",
  "CS_status_ocdu_QQQW": "视频呼叫",
  "CS_1_Automatic_Order_Mnnv": "自动分单中",
  "CS_optimazation_Make_sure_FVAQ": "请确认是否将{{workbench_name}}状态由{{status_one}}切换为{{status_two}}？切换后其余工作台的状态将会被设置为{{status_three}}。",
  "CS_1_Comments_RcMN": "评论",
  "CS_1_Notification_uJTM": "通知",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "请联系您的上级或当地客服权限管理员协助申请。",
  "status_400": "用餐中...",
  "refreshPage": "刷新页面",
  "countDownBegin": "",
  "infoChange": "已在其他页面切换系统品类，系统将不能保存您所做的更改，请刷新页面。",
  "view": "去查看",
  "online": "线上环境",
  "message": "消息通知",
  "changeStatusV1": "请确认是否将状态由",
  "changeStatusV2": "切换为",
  "changeStatusV3": "?",
  "time": "时间",
  "continue": "确认",
  "knowledge": "知识库",
  "status_500": "休息中...",
  "artificial": "人工消息",
  "countDownEnd": "s后可操作",
  "clickStartWorking": "为了准确记录数据，请在使用系统前点击【开始工作】按钮",
  "statusChange": "开始自动分配工单，需要将工作状态切换为“工作中”。",
  "CS_Workbench_There_are_wmir": "仍有进行中在线会话，无法切换工作状态。请先完成所有进行中会话。",
  "type": "消息类型",
  "status_200": "培训中...",
  "cancel": "取消",
  "logout": "退出",
  "sendTo": "收件人",
  "satisfaction_content": "你有一封问卷需要填写，这可能花费你5分钟左右的时间，如果你想现在完成他，你可以点击下面的链接，或者点击确认按钮，我们将为您打开问卷链接",
  "CS_Workbench_Open_the_lnHa": "开启在线客服功能，需要将工作状态切换为“工作中”。",
  "ticketNumber": " 个待处理工单",
  "more": "更多",
  "satisfaction_title": "你的新问卷",
  "pre": "预发环境",
  "customerService": "客服系统",
  "status_300": "会议中...",
  "sendFrom": "发件人",
  "youhave": "你有 ",
  "startWorking": "开始工作",
  "small": "验收环境",
  "offWorkV": "请确认是否下班，并结束今天的工作？",
  "read": "我已阅读",
  "Settings": "设置",
  "welcomeCS": "欢迎访问DiDi Global customer service系统！",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": ""
}